import Marquee from "react-fast-marquee";
import { clients, creditsMeta } from "../data/clients";

export default function MarqueeCredits() {
  return (
    <section
      data-testid="marquee-credits"
      className="w-full overflow-hidden border-y border-white/10 bg-[#0d0d0f] py-16"
    >
      <div className="mx-auto mb-8 flex max-w-[1400px] items-center justify-between px-6 md:px-16">
        <span className="font-hud text-[11px] uppercase tracking-[0.3em] text-white/45">
          {creditsMeta.reel}
        </span>
        <span className="flex items-center gap-2 font-hud text-[11px] uppercase tracking-[0.3em] text-[#CBFF3A]">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#CBFF3A]" />
          Rolling Credits
        </span>
      </div>

      <Marquee gradient={false} speed={45} className="py-2">
        {clients.map((c, i) => (
          <span key={`a-${i}`} className="mx-8 flex items-center gap-8">
            <span
              className={`font-display text-4xl font-600 italic tracking-tight sm:text-6xl ${
                i % 2 === 0 ? "text-[#ECEAE3]" : "credit-outline"
              }`}
            >
              {c}
            </span>
            <span className="h-2 w-2 rounded-full bg-[#CBFF3A]" />
          </span>
        ))}
      </Marquee>

      <Marquee gradient={false} speed={28} direction="right" className="mt-5 py-2 opacity-60">
        {clients.map((c, i) => (
          <span key={`b-${i}`} className="mx-6 flex items-center gap-6">
            <span className="font-hud text-xs uppercase tracking-[0.3em] text-white/50">
              {c}
            </span>
            <span className="font-hud text-xs text-[#CBFF3A]/60">/</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
